
import { defineComponent } from "vue";
import { OtherCar } from "@/cars/types";
import { Optional } from "@/globalTypes";
import { mapActions, mapGetters } from "vuex";

interface OtherCarInfoData {
  car: Optional<OtherCar>;
  isLoadingCar: Boolean;
}

export default defineComponent({
  data(): OtherCarInfoData {
    return {
      car: null,
      isLoadingCar: false,
    };
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  methods: {
    ...mapActions("cars", ["getCarByTypeId"]),
    getCar() {
      const typeId = this.$route.params.typeId;
      if (typeId && typeId !== this.getSelectedCar?.typeId.toString()) {
        this.getCarByTypeId(typeId).then((car) => {
          if (car.typeId !== this.getSelectedCar?.typeId) {
            this.car = car;
          }
        });
      } else {
        this.car = null;
      }
    },
    shouldShowError() {
      return (
        this.$route.params.typeId &&
        this.$route.params.typeId !== this.getSelectedCar?.typeId.toString()
      );
    },
  },
  watch: {
    "$route.params.typeId"() {
      this.getCar();
    },
    getSelectedCar() {
      this.getCar();
    },
  },
});
